import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';

export const existsInEntries = (item: IBackendCartEntries, entries: ICartEntry[]): boolean =>
  entries.some(
    (entry: ICartEntry) =>
      item.sanityId === entry.sanityId ||
      (entry.children.length ? existsInEntries(item, entry.children) : false)
  );
